import { Box, CardMedia, Typography } from "@mui/material";
import { motion } from "framer-motion";

const BoxMotion = motion(Box);
const CardMediaMotion = motion(CardMedia);
const TypographyMotion = motion(Typography);

export { BoxMotion, CardMediaMotion, TypographyMotion };
